<template>
  <VBtn prepend-icon="tabler-photo-plus" @click="triggerFileInput">
    Tải lên tệp
  </VBtn>
  <input
    ref="fileInput"
    type="file"
    style="display: none"
    @change="handleFileUpload"
  />
</template>

<script setup>
import {ref} from 'vue'

const emit = defineEmits(['upload', 'click'])

const fileInput = ref(null)

const triggerFileInput = () => {
  fileInput.value?.click()
  emit('click')
}

const handleFileUpload = (event) => {
  const file = event.target.files[0]
  if (file) {
    emit('upload', file)
  }
}
</script>
